import React from 'react';
import { useDispatch } from 'react-redux';
import { IconButton, Tooltip } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import { useTranslation } from 'react-i18next';
import { ExitToApp } from '@mui/icons-material';
import { logout } from 'redux/Account/AccountAction';
const useStyles = makeStyles(() => ({
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 14,
      paddingBottom: 14,
    },
  },
  perfectScrollbarLanguage: {
    height: 'fit-content',
  },
  menuItemRoot: {
    paddingTop: 0,
    paddingBottom: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  popoverRoot: {
    '& .MuiPopover-paper': {
      width: 205,
    },
  },
  caret: {
    transition: 'all 150ms ease-in',
    display: 'inline-block',
    width: '0',
    height: '0',
    marginLeft: '4px',
    verticalAlign: 'middle',
    borderTop: '4px solid',
    borderRight: '4px solid transparent',
    borderLeft: '4px solid transparent',
  },
  caretActive: {
    transform: 'rotate(180deg)',
  },
  caretDropup: {
    transform: 'rotate(180deg)',
  },
  white: {
    color: 'white',
  },
}));

const LogoutButton = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleLogout = ({ locale, icon }) => {
    dispatch(logout());
  };

  return (
    <Tooltip title={t('popup.logout')}>
      <IconButton size="small" onClick={handleLogout} className={classes.white} data-tut="reactour__logout">
        <ExitToApp sx={{ ml: 2 }} />
      </IconButton>
    </Tooltip>
  );
};

export default LogoutButton;
